import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EDiffPriceTrand, IMarketTrendsData } from 'shared/types/marketTrends';

const initialState: IMarketTrendsData = {
  marketTrand: [],
  houseTrand: [],
  averagePrice: '',
  averageSqmPrice: '',
  diffPercent: '',
  diffPrice: '',
  diffPriceTrand: EDiffPriceTrand.NoChange,
};

const marketTrendsDataSlice = createSlice({
  initialState,
  name: 'marketTrendsData',
  reducers: {
    setMarketTrends: (_, action: PayloadAction<IMarketTrendsData>) => action.payload,
  },
});

export const {
  reducer: marketTrendsDataReducer,
  actions: { setMarketTrends },
} = marketTrendsDataSlice;
